$(document).ready(function () {
  if ($(".faq-listing").length) {
    var stickyNavTop = $(".faq-listing").offset().top;
    var stickyNav = function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > stickyNavTop) {
        $(".faq-listing__side-menu ul").addClass("sticky-top");
      } else {
        $(".faq-listing__side-menu ul").removeClass("sticky-top");
      }
    };

    stickyNav();
    $(window).scroll(function () {
      stickyNav();
    });
  }
});

$(document).ready(function () {
  $(".faq-listing__side-menu ul li ").click(function () {
    $("li ").removeClass("active");
    $(this).addClass("active");
  });
});

